import { c as _c } from "react/compiler-runtime";
import React, { useCallback, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { groupBy } from 'lodash';
import classNames from 'classnames';
import useScreen from 'hooks/useScreen';
import Placeholder from 'components/consumer/Placeholder';
import PDPActiveFabric from 'components/consumer/PDP/PDPActiveFabric';
import PDPDecideLaterPromo from 'components/consumer/PDP/PDPDecideLaterPromo';
import PDPUpholsterySortBy from 'components/consumer/PDP/PDPUpholsterySortBy';
import MaterialThumbnailGroup from 'components/consumer/MaterialThumbnailGroup';
import PDPUpholsteryFilters from 'components/consumer/PDP/PDPUpholsteryFilters';
import PDPFabricDetailSidebar from 'components/consumer/PDP/PDPFabricDetailSidebar';
import PDPFreeSwatchKitButton from 'components/consumer/PDP/PDPFreeSwatchKitButton';
import PDPOrderSwatchesSidebar from 'components/consumer/PDP/PDPOrderSwatchesSidebar';
import PDPUpholsteryColorFilters from 'components/consumer/PDP/PDPUpholsteryColorFilters';
import { PDP_CUSTOMIZE_TAB_ID, PDP_READYTOSHIP_TAB_ID, PDP_DECIDELATER_TAB_ID, FABRIC_PRODUCT_OPTION_ID, PDP_NAMED_FILTERS, PANTONE_FABRIC_CONFIG } from 'commons/constants';
import { materialPropType, productFilterTypes } from 'types/PDPTypes';
import useFabricDetails from 'data-hooks/useFabricDetails';
import useIsTouchDevice from 'hooks/useIsTouchDevice';
import usePdpIsModularBYOProduct from 'components/consumer/PDP/state/context/usePdpIsModularBYOProduct';
import usePdpSelectedCustomizerTab from 'components/consumer/PDP/state/pdpSelectedCustomizerTab/usePdpSelectedCustomizerTab';
import CtaButton from 'components/essentials/Cta/CtaButton';
import useProjectResetConfig from 'data-hooks/useProjectResetConfig';
import MaterialThumbnailGroupPlaceholder from 'components/consumer/MaterialThumbnailGroup/MaterialThumbnailGroupPlaceholder';
import FlyoutContainer from '../../FlyoutContainer';
import PDPSelectUpholsteryDecideLater from './PDPSelectUpholsteryDecideLater';
const {
  pantoneFabricSkus
} = PANTONE_FABRIC_CONFIG;
const tiers = {
  1: {
    title: 'Tier 1',
    desc: 'Readily available fabrics that bring an eye-catching look to your piece at a great value.'
  },
  2: {
    title: 'Tier 2',
    desc: 'Kick things up a notch with fabrics that show off more rich colors, textures, and durability.'
  },
  3: {
    title: 'Tier 3',
    desc: 'Got an active home? Check out these fabrics that showcase top notch performance finishes while still looking stylish.'
  },
  4: {
    title: 'Tier 4',
    desc: 'As luxe as it gets, this tier includes our branded performance fabrics and stain resistant finish fabrics, ready to take on all life throws its way in sophisticated style.'
  }
};
const NUMBER_OF_SWATCHES_PER_ROW_ON_DESKTOP = 9;
const MAX_SWATCHES_BEFORE_SHOW_ALL_BUTTON = 3 * NUMBER_OF_SWATCHES_PER_ROW_ON_DESKTOP;
const SORT_BY_OPTIONS = {
  POPULARITY: 'popularity',
  FAMILY: 'family',
  TIER: 'tier'
};
const moveMaterialToSecondPosition = (materials, materialSku) => {
  if (materials?.length && materialSku && materials[0]?.sku !== materialSku) {
    const filteredMaterials = materials.filter(({
      sku
    }) => sku !== materialSku);
    const material = materials.find(({
      sku
    }) => sku === materialSku);
    const [firstMaterial, ...restMaterials] = filteredMaterials;
    return [firstMaterial, material, ...restMaterials];
  }
  return materials;
};
const PDPSelectUpholsteryUI = t0 => {
  const $ = _c(133);
  const {
    activeColorFilters,
    activeNamedFilters,
    allMaterialsLength,
    clearAllFilters,
    disabledMaterialIds,
    fabricFavProps,
    filterCounts: t1,
    flashSaleOptionIds: t2,
    isClearanceFabricAvailable,
    isEditOrder: t3,
    isSelectedOptionsQuickship,
    loading,
    materials,
    mode: t4,
    onMoreMaterialsClick,
    onOptionValueHover,
    onOptionValueSelection,
    selectedMaterial,
    selectedOptionsStockQty,
    toggleColorFilter,
    toggleNamedFilter,
    upholsteryFilteredEvent,
    upholsteryOptionId,
    upholsteryOptionName
  } = t0;
  let t5;
  if ($[0] !== t1) {
    t5 = t1 === undefined ? {} : t1;
    $[0] = t1;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  const filterCounts = t5;
  let t6;
  if ($[2] !== t2) {
    t6 = t2 === undefined ? [] : t2;
    $[2] = t2;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  const flashSaleOptionIds = t6;
  const isEditOrder = t3 === undefined ? false : t3;
  const mode = t4 === undefined ? "pdp" : t4;
  const {
    isDesktop,
    isMobile
  } = useScreen();
  const pdpIsModularBYOProduct = usePdpIsModularBYOProduct();
  const [selectedSortOption, setSelectedSortOption] = useState(SORT_BY_OPTIONS.POPULARITY);
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const pdpSelectedCustomizerTab = usePdpSelectedCustomizerTab();
  const [isOrderSwatchesSidebarOpen, setIsOrderSwatchesSidebarOpen] = useState(false);
  const [galleryType, setGalleryType] = useState("");
  let t7;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {};
    $[4] = t7;
  } else {
    t7 = $[4];
  }
  const [sortByFlyOutContent, setSortByFlyOutContent] = useState(t7);
  const [isSortByFlyOutVisible, setIsSortByFlyOutVisible] = useState(false);
  const {
    data: t8
  } = useFabricDetails(selectedMaterial?.materialId);
  const {
    selectedFabric
  } = t8;
  const isTouchDevice = useIsTouchDevice();
  const isPdpMode = mode === "pdp";
  let t9;
  if ($[5] !== materials || $[6] !== selectedSortOption) {
    t9 = selectedSortOption === SORT_BY_OPTIONS.FAMILY ? groupBy(materials, "groupName") : {};
    $[5] = materials;
    $[6] = selectedSortOption;
    $[7] = t9;
  } else {
    t9 = $[7];
  }
  const materialsGroupedByFamily = t9;
  let t10;
  if ($[8] !== materials || $[9] !== selectedSortOption) {
    t10 = selectedSortOption === SORT_BY_OPTIONS.TIER ? groupBy(materials, SORT_BY_OPTIONS.TIER) : {};
    $[8] = materials;
    $[9] = selectedSortOption;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  const materialsGroupedByTier = t10;
  const isQuickview = mode === "quickview";
  const quickviewNumberOfFabricsToShow = isMobile ? 5 : 8;
  const limitNumberShownForQuickview = isQuickview && allMaterialsLength > quickviewNumberOfFabricsToShow;
  const {
    data: projectResetConfig
  } = useProjectResetConfig();
  let t11;
  if ($[11] !== projectResetConfig) {
    t11 = projectResetConfig ?? {};
    $[11] = projectResetConfig;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  const {
    isProjectResetEnabled,
    projectResetNewFabricSkus
  } = t11;
  let t12;
  bb0: {
    let t13;
    if ($[13] !== isProjectResetEnabled || $[14] !== isQuickview || $[15] !== materials || $[16] !== projectResetNewFabricSkus?.[0]) {
      t13 = isQuickview ? moveMaterialToSecondPosition(materials, isProjectResetEnabled ? projectResetNewFabricSkus?.[0] : pantoneFabricSkus?.[0]) : materials;
      $[13] = isProjectResetEnabled;
      $[14] = isQuickview;
      $[15] = materials;
      $[16] = projectResetNewFabricSkus?.[0];
      $[17] = t13;
    } else {
      t13 = $[17];
    }
    const materialsPantoneFabricAsSecond = t13;
    if (limitNumberShownForQuickview) {
      let t14;
      if ($[18] !== materialsPantoneFabricAsSecond || $[19] !== quickviewNumberOfFabricsToShow) {
        t14 = materialsPantoneFabricAsSecond.slice(0, quickviewNumberOfFabricsToShow);
        $[18] = materialsPantoneFabricAsSecond;
        $[19] = quickviewNumberOfFabricsToShow;
        $[20] = t14;
      } else {
        t14 = $[20];
      }
      t12 = t14;
      break bb0;
    }
    t12 = materialsPantoneFabricAsSecond;
  }
  const ungroupedMaterialsArray = t12;
  const moreMaterialsCount = limitNumberShownForQuickview ? allMaterialsLength - quickviewNumberOfFabricsToShow : undefined;
  const ungroupedMaterialsLength = ungroupedMaterialsArray?.length ?? 0;
  const [hasShowAllFabricsButtonBeenClicked, setHasShowAllFabricsButtonBeenClicked] = useState(false);
  const isAllFabricsShown = !activeNamedFilters.length;
  const showShowAllFabricsButton = isDesktop && isAllFabricsShown && !loading && !hasShowAllFabricsButtonBeenClicked && ungroupedMaterialsLength > MAX_SWATCHES_BEFORE_SHOW_ALL_BUTTON;
  let t13;
  if ($[21] !== showShowAllFabricsButton || $[22] !== ungroupedMaterialsArray) {
    t13 = showShowAllFabricsButton ? ungroupedMaterialsArray.slice(0, MAX_SWATCHES_BEFORE_SHOW_ALL_BUTTON) : ungroupedMaterialsArray;
    $[21] = showShowAllFabricsButton;
    $[22] = ungroupedMaterialsArray;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  const ungroupedMaterialsToShow = t13;
  let t14;
  if ($[24] !== isTouchDevice) {
    t14 = upholsteryOptionNameVal => {
      const tapOrClick = isTouchDevice ? "tap" : "click";
      return upholsteryOptionNameVal === "Fabric" ? `Double-${tapOrClick} a fabric to add to your favorites` : upholsteryOptionNameVal === "Leather" ? `Double-${tapOrClick} a leather to add to your favorites` : "Double tap to favorite";
    };
    $[24] = isTouchDevice;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  const getFabricFavInfoToShow = t14;
  const noActiveNamedFilters = !activeNamedFilters.length;
  const noActiveColorFilters = activeColorFilters.length === 0;
  const noActiveFilters = noActiveNamedFilters && noActiveColorFilters;
  const t15 = !noActiveFilters;
  let t16;
  if ($[26] !== noActiveFilters || $[27] !== t15) {
    t16 = classNames("text-xs font-bold p-[5px] underline", {
      "text-gray-light4 pointer-events-none": noActiveFilters,
      "text-red hover:text-red-dark": t15
    });
    $[26] = noActiveFilters;
    $[27] = t15;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] !== clearAllFilters || $[30] !== noActiveFilters) {
    t17 = () => {
      if (!noActiveFilters) {
        clearAllFilters();
      }
    };
    $[29] = clearAllFilters;
    $[30] = noActiveFilters;
    $[31] = t17;
  } else {
    t17 = $[31];
  }
  let t18;
  if ($[32] !== t16 || $[33] !== t17) {
    t18 = <button type="button" className={t16} onClick={t17}>Clear All</button>;
    $[32] = t16;
    $[33] = t17;
    $[34] = t18;
  } else {
    t18 = $[34];
  }
  const clearAllFiltersButton = t18;
  let t19;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = (content, isVisible) => {
      setSortByFlyOutContent(content);
      setIsSortByFlyOutVisible(isVisible);
    };
    $[35] = t19;
  } else {
    t19 = $[35];
  }
  const onToggleFlyOut = t19;
  let t20;
  if ($[36] !== isSortByFlyOutVisible || $[37] !== sortByFlyOutContent) {
    t20 = isSortByFlyOutVisible && <FlyoutContainer top={sortByFlyOutContent.top > 300 ? sortByFlyOutContent.top - 300 : sortByFlyOutContent.top} title={sortByFlyOutContent.title} content={sortByFlyOutContent.content} subTitle={sortByFlyOutContent.subTitle} imageUrl={sortByFlyOutContent.imageUrl} titleInfo={sortByFlyOutContent.titleInfo} titleExtra={sortByFlyOutContent.titleExtra} subSubTitle={sortByFlyOutContent.subSubTitle} onClose={() => setIsSortByFlyOutVisible(false)} isOpen={isSortByFlyOutVisible} />;
    $[36] = isSortByFlyOutVisible;
    $[37] = sortByFlyOutContent;
    $[38] = t20;
  } else {
    t20 = $[38];
  }
  const flyoutContainerContent = t20;
  let t21;
  if ($[39] !== disabledMaterialIds || $[40] !== fabricFavProps || $[41] !== flashSaleOptionIds || $[42] !== isEditOrder || $[43] !== materialsGroupedByFamily || $[44] !== onOptionValueHover || $[45] !== onOptionValueSelection || $[46] !== pdpIsModularBYOProduct || $[47] !== selectedMaterial || $[48] !== upholsteryOptionId) {
    t21 = Object.keys(materialsGroupedByFamily).sort().map(groupName => <div key={groupName} className="mb-8"><div className="text-sm font-bold text-gray">{groupName}</div><MaterialThumbnailGroup disabledMaterialIds={disabledMaterialIds} fabricFavProps={fabricFavProps} flashSaleOptionIds={flashSaleOptionIds} isEditOrder={isEditOrder} isModularBundleProduct={pdpIsModularBYOProduct} materials={materialsGroupedByFamily[groupName]} onClick={onOptionValueSelection} onHover={onOptionValueHover} onToggleFlyOut={onToggleFlyOut} optionId={upholsteryOptionId} selectedMaterial={selectedMaterial} /></div>);
    $[39] = disabledMaterialIds;
    $[40] = fabricFavProps;
    $[41] = flashSaleOptionIds;
    $[42] = isEditOrder;
    $[43] = materialsGroupedByFamily;
    $[44] = onOptionValueHover;
    $[45] = onOptionValueSelection;
    $[46] = pdpIsModularBYOProduct;
    $[47] = selectedMaterial;
    $[48] = upholsteryOptionId;
    $[49] = t21;
  } else {
    t21 = $[49];
  }
  let t22;
  if ($[50] !== t21) {
    t22 = <div className="p-6 max-h-[472px] overflow-y-auto bg-gray-light9 border border-solid border-gray-light7">{t21}</div>;
    $[50] = t21;
    $[51] = t22;
  } else {
    t22 = $[51];
  }
  const sortByFamilyMaterialThumbnails = t22;
  let t23;
  if ($[52] !== materialsGroupedByTier) {
    t23 = Object.keys(materialsGroupedByTier);
    $[52] = materialsGroupedByTier;
    $[53] = t23;
  } else {
    t23 = $[53];
  }
  let t24;
  if ($[54] !== disabledMaterialIds || $[55] !== fabricFavProps || $[56] !== flashSaleOptionIds || $[57] !== isEditOrder || $[58] !== materialsGroupedByTier || $[59] !== onOptionValueHover || $[60] !== onOptionValueSelection || $[61] !== pdpIsModularBYOProduct || $[62] !== selectedMaterial || $[63] !== t23 || $[64] !== upholsteryOptionId) {
    t24 = <div>{t23.map(tierId => {
        const tier = tiers[tierId];
        return tier ? <div key={tierId} className="mt-8"><div className="text-sm font-bold text-gray">{tier.title}</div><div className="text-xs text-gray mb-[1.2rem]">{tier.desc}</div><MaterialThumbnailGroup disabledMaterialIds={disabledMaterialIds} fabricFavProps={fabricFavProps} flashSaleOptionIds={flashSaleOptionIds} isEditOrder={isEditOrder} isModularBundleProduct={pdpIsModularBYOProduct} materials={materialsGroupedByTier[tierId]} onClick={onOptionValueSelection} onHover={onOptionValueHover} optionId={upholsteryOptionId} selectedMaterial={selectedMaterial} /></div> : <div />;
      })}</div>;
    $[54] = disabledMaterialIds;
    $[55] = fabricFavProps;
    $[56] = flashSaleOptionIds;
    $[57] = isEditOrder;
    $[58] = materialsGroupedByTier;
    $[59] = onOptionValueHover;
    $[60] = onOptionValueSelection;
    $[61] = pdpIsModularBYOProduct;
    $[62] = selectedMaterial;
    $[63] = t23;
    $[64] = upholsteryOptionId;
    $[65] = t24;
  } else {
    t24 = $[65];
  }
  const sortByTierMaterialThumbnails = t24;
  let t25;
  if ($[66] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = () => {
      setGalleryType("");
      setSidebarOpen(false);
    };
    $[66] = t25;
  } else {
    t25 = $[66];
  }
  const onCloseCallback = t25;
  const materialThumbnailVariant = mode === "quickview" ? "PDPSelectUpholsteryUI--quickview" : "PDPSelectUpholsteryUI";
  const t26 = mode !== "quickview";
  let t27;
  if ($[67] !== t26) {
    t27 = classNames("relative", {
      "[border-bottom:1px_solid_#e5e5e5] mb-2 pb-8": t26
    });
    $[67] = t26;
    $[68] = t27;
  } else {
    t27 = $[68];
  }
  let t28;
  if ($[69] !== pdpSelectedCustomizerTab) {
    t28 = pdpSelectedCustomizerTab === PDP_DECIDELATER_TAB_ID ? <PDPSelectUpholsteryDecideLater /> : null;
    $[69] = pdpSelectedCustomizerTab;
    $[70] = t28;
  } else {
    t28 = $[70];
  }
  let t29;
  if ($[71] !== activeColorFilters || $[72] !== activeNamedFilters || $[73] !== isMobile || $[74] !== mode || $[75] !== selectedSortOption || $[76] !== toggleColorFilter || $[77] !== upholsteryFilteredEvent || $[78] !== upholsteryOptionId) {
    t29 = mode !== "quickview" && upholsteryOptionId === FABRIC_PRODUCT_OPTION_ID && !isMobile ? <div className="items-center flex justify-between w-full mb-4"><h4 className="text-base font-bold">Filter by color:</h4><PDPUpholsteryColorFilters activeColorFilters={activeColorFilters} toggleColorFilter={updatedColor => {
        toggleColorFilter(updatedColor);
        upholsteryFilteredEvent(activeNamedFilters, updatedColor, selectedSortOption);
      }} /></div> : <div />;
    $[71] = activeColorFilters;
    $[72] = activeNamedFilters;
    $[73] = isMobile;
    $[74] = mode;
    $[75] = selectedSortOption;
    $[76] = toggleColorFilter;
    $[77] = upholsteryFilteredEvent;
    $[78] = upholsteryOptionId;
    $[79] = t29;
  } else {
    t29 = $[79];
  }
  let t30;
  if ($[80] !== activeColorFilters || $[81] !== activeNamedFilters || $[82] !== clearAllFiltersButton || $[83] !== disabledMaterialIds || $[84] !== fabricFavProps || $[85] !== filterCounts || $[86] !== flashSaleOptionIds || $[87] !== flyoutContainerContent || $[88] !== getFabricFavInfoToShow || $[89] !== isClearanceFabricAvailable || $[90] !== isDesktop || $[91] !== isEditOrder || $[92] !== isMobile || $[93] !== isOrderSwatchesSidebarOpen || $[94] !== isPdpMode || $[95] !== isSelectedOptionsQuickship || $[96] !== loading || $[97] !== materialThumbnailVariant || $[98] !== mode || $[99] !== moreMaterialsCount || $[100] !== onMoreMaterialsClick || $[101] !== onOptionValueHover || $[102] !== onOptionValueSelection || $[103] !== pdpIsModularBYOProduct || $[104] !== pdpSelectedCustomizerTab || $[105] !== selectedFabric || $[106] !== selectedMaterial || $[107] !== selectedOptionsStockQty || $[108] !== selectedSortOption || $[109] !== showShowAllFabricsButton || $[110] !== sortByFamilyMaterialThumbnails || $[111] !== sortByTierMaterialThumbnails || $[112] !== toggleColorFilter || $[113] !== toggleNamedFilter || $[114] !== ungroupedMaterialsArray || $[115] !== ungroupedMaterialsToShow || $[116] !== upholsteryFilteredEvent || $[117] !== upholsteryOptionId || $[118] !== upholsteryOptionName) {
    t30 = pdpSelectedCustomizerTab === PDP_CUSTOMIZE_TAB_ID || pdpSelectedCustomizerTab === PDP_READYTOSHIP_TAB_ID ? <div>{!!isPdpMode && pdpSelectedCustomizerTab === PDP_CUSTOMIZE_TAB_ID ? upholsteryOptionName === "Leather" ? <div className="text-sm -mt-8 mx-0 mb-8 font-bold">{getFabricFavInfoToShow("Leather")}</div> : <>{isMobile && <div className="flex justify-between my-1"><h4 className="text-base font-bold">Filter by color</h4>{clearAllFiltersButton}</div>}<div className="mt-0 mx-0 space-y-2 max-[1023px]:-ml-10 max-[1023px]:-mr-5 [&::-webkit-scrollbar]:max-[1023px]:hidden max-[1023px]:pb-6">{isMobile && <PDPUpholsteryColorFilters activeColorFilters={activeColorFilters} showRowInMobile={true} toggleColorFilter={color => {
            toggleColorFilter(color);
            upholsteryFilteredEvent(activeNamedFilters, color, selectedSortOption);
          }} showMobileColorFilter={true} />}<PDPUpholsteryFilters clearAllFiltersButton={clearAllFiltersButton} filtersCollectionVisible={activeNamedFilters} setFiltersCollectionVisible={updatedFilterType => {
            toggleNamedFilter(updatedFilterType);
            upholsteryFilteredEvent(updatedFilterType, activeColorFilters, selectedSortOption);
          }} filterCounts={filterCounts} loading={loading} showFabricFavs={!!fabricFavProps.actions.setOptionAsFav} isClearanceFabricAvailable={isClearanceFabricAvailable} fabricFavInfoToShow={activeNamedFilters.length === 1 && activeNamedFilters[0] === PDP_NAMED_FILTERS.FAVORITES ? getFabricFavInfoToShow(upholsteryOptionName) : ""} variant="PDPSelectUpholstery" />{!loading && ungroupedMaterialsArray.length === 0 && <span className="text-xs font-bold text-gray">Try removing a filter to see more fabric options</span>}</div></> : <div />}{mode !== "quickview" && upholsteryOptionId === FABRIC_PRODUCT_OPTION_ID && <div className="hidden sm:block"><PDPUpholsterySortBy selectedOption={selectedSortOption} setSelectedOption={updatedSortOption => {
          setSelectedSortOption(updatedSortOption);
          upholsteryFilteredEvent(activeNamedFilters, activeColorFilters, updatedSortOption);
        }} /></div>}<div className="flex flex-row justify-between"><PDPActiveFabric isEditOrder={isEditOrder} isModularBundleProduct={pdpIsModularBYOProduct} isSelectedOptionsQuickship={pdpSelectedCustomizerTab === PDP_READYTOSHIP_TAB_ID && isSelectedOptionsQuickship} loading={loading} onClick={() => {
          setGalleryType("FabricMultiImg");
          setSidebarOpen(true);
        }} selectedOption={selectedMaterial} selectedOptionsStockQty={selectedOptionsStockQty} size={mode === "quickview" ? "xs" : undefined} showInfoIcon={!!selectedFabric} />{!!isPdpMode && pdpSelectedCustomizerTab !== PDP_READYTOSHIP_TAB_ID && !isEditOrder ? loading ? <Placeholder type="rect" loading={true} style={{
          height: "43px",
          width: "152px",
          borderRadius: "43px"
        }} /> : <div className="mb-2"><PDPFreeSwatchKitButton styling="rainbow-button" onClick={() => {
            setIsOrderSwatchesSidebarOpen(true);
          }} /><PDPOrderSwatchesSidebar show={isOrderSwatchesSidebarOpen} onClose={() => {
            setIsOrderSwatchesSidebarOpen(false);
          }} closeSlidePanel={() => {
            setIsOrderSwatchesSidebarOpen(false);
          }} /></div> : <div />}</div>{selectedSortOption === SORT_BY_OPTIONS.FAMILY ? <>{flyoutContainerContent}{sortByFamilyMaterialThumbnails}</> : selectedSortOption === SORT_BY_OPTIONS.TIER ? sortByTierMaterialThumbnails : <div className={classNames("max-[1023px]:-ml-5 max-[1023px]:-mr-5 max-[1023px]:md:ml-[-3.333vw] max-[1023px]:md:mr-[-3.333vw]", {
        "max-[1023px]:md:!m-0": mode === "quickview"
      })}>{loading ? <MaterialThumbnailGroupPlaceholder variant={materialThumbnailVariant} /> : <MaterialThumbnailGroup disabledMaterialIds={disabledMaterialIds} enableFlyout={mode === "pdp"} fabricFavProps={fabricFavProps} flashSaleOptionIds={flashSaleOptionIds} isEditOrder={isEditOrder} isModularBundleProduct={pdpIsModularBYOProduct} materials={ungroupedMaterialsToShow} moreMaterialsCount={moreMaterialsCount} onClick={onOptionValueSelection} onHover={onOptionValueHover} onMoreMaterialsClick={onMoreMaterialsClick} optionId={upholsteryOptionId} selectedMaterial={selectedMaterial} showMoreMaterialsOnDesktop={mode === "quickview"} variant={materialThumbnailVariant} />}{showShowAllFabricsButton && <div className="relative pt-6 mt-[-52px] bg-white bg-opacity-70"><div className="bg-white px-[6px]"><CtaButton block={true} color="brand" onClick={() => {
              setHasShowAllFabricsButtonBeenClicked(true);
            }} spacing="sm" styling="outline-button">Show All Fabrics</CtaButton></div></div>}</div>}{!!isPdpMode && pdpSelectedCustomizerTab !== PDP_READYTOSHIP_TAB_ID && !isEditOrder && isDesktop ? <div className="mt-4 mx-0 mb-0"><PDPDecideLaterPromo /></div> : <div />}</div> : <div />;
    $[80] = activeColorFilters;
    $[81] = activeNamedFilters;
    $[82] = clearAllFiltersButton;
    $[83] = disabledMaterialIds;
    $[84] = fabricFavProps;
    $[85] = filterCounts;
    $[86] = flashSaleOptionIds;
    $[87] = flyoutContainerContent;
    $[88] = getFabricFavInfoToShow;
    $[89] = isClearanceFabricAvailable;
    $[90] = isDesktop;
    $[91] = isEditOrder;
    $[92] = isMobile;
    $[93] = isOrderSwatchesSidebarOpen;
    $[94] = isPdpMode;
    $[95] = isSelectedOptionsQuickship;
    $[96] = loading;
    $[97] = materialThumbnailVariant;
    $[98] = mode;
    $[99] = moreMaterialsCount;
    $[100] = onMoreMaterialsClick;
    $[101] = onOptionValueHover;
    $[102] = onOptionValueSelection;
    $[103] = pdpIsModularBYOProduct;
    $[104] = pdpSelectedCustomizerTab;
    $[105] = selectedFabric;
    $[106] = selectedMaterial;
    $[107] = selectedOptionsStockQty;
    $[108] = selectedSortOption;
    $[109] = showShowAllFabricsButton;
    $[110] = sortByFamilyMaterialThumbnails;
    $[111] = sortByTierMaterialThumbnails;
    $[112] = toggleColorFilter;
    $[113] = toggleNamedFilter;
    $[114] = ungroupedMaterialsArray;
    $[115] = ungroupedMaterialsToShow;
    $[116] = upholsteryFilteredEvent;
    $[117] = upholsteryOptionId;
    $[118] = upholsteryOptionName;
    $[119] = t30;
  } else {
    t30 = $[119];
  }
  let t31;
  if ($[120] !== t28 || $[121] !== t29 || $[122] !== t30) {
    t31 = <div>{t28}{t29}{t30}</div>;
    $[120] = t28;
    $[121] = t29;
    $[122] = t30;
    $[123] = t31;
  } else {
    t31 = $[123];
  }
  const t32 = !!selectedMaterial?.materialId && isSidebarOpen;
  const t33 = selectedMaterial?.materialId;
  let t34;
  if ($[124] !== galleryType || $[125] !== mode || $[126] !== t32 || $[127] !== t33) {
    t34 = <PDPFabricDetailSidebar isOpen={t32} onClose={onCloseCallback} fabricId={t33} mode={mode} galleryType={galleryType} mobileHideHeader={true} />;
    $[124] = galleryType;
    $[125] = mode;
    $[126] = t32;
    $[127] = t33;
    $[128] = t34;
  } else {
    t34 = $[128];
  }
  let t35;
  if ($[129] !== t27 || $[130] !== t31 || $[131] !== t34) {
    t35 = <div className={t27}>{t31}{t34}</div>;
    $[129] = t27;
    $[130] = t31;
    $[131] = t34;
    $[132] = t35;
  } else {
    t35 = $[132];
  }
  return t35;
};
PDPSelectUpholsteryUI.propTypes = {
  activeNamedFilters: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  allMaterialsLength: PropTypes.number,
  disabledMaterialIds: PropTypes.arrayOf(PropTypes.number),
  fabricFavProps: PropTypes.object,
  filterCounts: productFilterTypes,
  flashSaleOptionIds: PropTypes.arrayOf(PropTypes.number),
  isClearanceFabricAvailable: PropTypes.bool,
  isEditOrder: PropTypes.bool,
  isSelectedOptionsQuickship: PropTypes.bool,
  loading: PropTypes.bool,
  materials: PropTypes.arrayOf(materialPropType),
  mode: PropTypes.oneOf(['pdp', 'quickview']),
  onMoreMaterialsClick: PropTypes.func,
  onOptionValueHover: PropTypes.func,
  onOptionValueSelection: PropTypes.func,
  activeColorFilters: PropTypes.array,
  selectedMaterial: materialPropType,
  selectedOptionsStockQty: PropTypes.number,
  toggleColorFilter: PropTypes.func,
  toggleNamedFilter: PropTypes.func,
  upholsteryFilteredEvent: PropTypes.func,
  upholsteryOptionId: PropTypes.number,
  upholsteryOptionName: PropTypes.string
};
export default PDPSelectUpholsteryUI;